import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-table-icon',
  templateUrl: 'chart-table-icon.component.html'
})
export class ChartTableIconComponent {
  constructor() {}
}
